import React from "react";
import Table, { TableButton, KebabMenu } from "../../../components/Common/Table";
import Button from "../../../components/Common/Button";
import { FaMobile, FaChartLine } from "react-icons/fa";
import { microgridTableColumns, MICROGRIDS_PAGE_TITLE } from "../dataFiles/microgridsPageDataFile";

export default function MicrogridTable({
  microgrids = [],
  branchName,
  customerName,
  activeMicrogridName,
  onRowClick,
  onViewDevices,
  onViewSimulations,
  onEdit,
  onDelete,
  onAddMicrogrid,
  isCustomer,
}) {
  const columns = [
    ...microgridTableColumns,
    {
      key: "actions",
      header: "Actions",
      align: "right",
      width: "140px",
      render: (row) => (
        <div className="wg-table__actions">
          {!isCustomer && (
            <TableButton
              variant="icon"
              onClick={(e) => { e.stopPropagation(); onViewDevices(row); }}
              title="View Devices"
            >
              <FaMobile size={16} />
            </TableButton>
          )}
          <TableButton
            variant="icon"
            onClick={(e) => { e.stopPropagation(); onViewSimulations(row); }}
            title="View Simulations"
          >
            <FaChartLine size={16} />
          </TableButton>
          {!isCustomer && (
            <KebabMenu
              items={[
                { label: "Edit Meter", onClick: () => onEdit(row) },
                // Only when the page passes onDelete and has marked this row
                // as the viewed customer's alone; anything else gets no Delete.
                ...(onDelete && row.deletable === true
                  ? [{ label: "Delete Microgrid", onClick: () => onDelete(row) }]
                  : []),
              ]}
            />
          )}
        </div>
      ),
    },
  ];

  return (
    <Table
      columns={columns}
      data={microgrids}
      rowKey="name"
      activeRowKey={activeMicrogridName}
      hoverable
      onRowClick={onRowClick}
      emptyState="No Microgrids available."
      toolbar={{
        left: (
          <div>
            <h2 className="wg-page-header">{MICROGRIDS_PAGE_TITLE}</h2>
            {(branchName || customerName) && (
              <p style={{ fontSize: "13px", color: "#64748b", margin: "4px 0 0 0" }}>
                {[branchName, customerName].filter(Boolean).join(" - ")} &middot; {microgrids.length} {microgrids.length === 1 ? "microgrid" : "microgrids"}
              </p>
            )}
          </div>
        ),
        right: !isCustomer && onAddMicrogrid && (
          <Button onClick={onAddMicrogrid}>+ New Microgrid</Button>
        ),
      }}
    />
  );
}
